"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flagFieldOptions = exports.recurringEditable = exports.clrFieldOptions = exports.fieldData = exports.availableColumns = exports.requiredColumns = exports.getAvailableColumns = exports.getColumnDefaults = void 0;
const transactionsConfigQUICKEN_1 = require("./transactionsConfigQUICKEN");
function getColumnDefaults(type = 'default') {
    const defaults = transactionsConfigQUICKEN_1.columnDefaults;
    const key = type && (type === null || type === void 0 ? void 0 : type.toLowerCase());
    return defaults[key] || defaults.default;
}
exports.getColumnDefaults = getColumnDefaults;
function getAvailableColumns(type = 'default') {
    const defaults = transactionsConfigQUICKEN_1.availableColumns;
    const key = type && (type === null || type === void 0 ? void 0 : type.toLowerCase());
    return defaults[key] || defaults.default;
}
exports.getAvailableColumns = getAvailableColumns;
exports.requiredColumns = transactionsConfigQUICKEN_1.requiredColumns;
exports.availableColumns = transactionsConfigQUICKEN_1.availableColumns;
exports.fieldData = transactionsConfigQUICKEN_1.fieldData;
exports.clrFieldOptions = transactionsConfigQUICKEN_1.clrFieldOptions;
exports.recurringEditable = transactionsConfigQUICKEN_1.recurringEditable;
exports.flagFieldOptions = null;
